import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Repeat } from "lucide-react";

export default function SubscriptionsTab() {
  const [offers, setOffers] = useState(null);
  const [active, setActive] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const [{ data: o }, { data: a }] = await Promise.all([
          api.get("/subscriptions/offers"),
          api.get("/subscriptions/active"),
        ]);
        setOffers(o); setActive(a);
      } catch { toast.error("Couldn't load subscriptions"); }
    })();
  }, []);

  if (!offers || !active) return <div className="nb-card-flat p-8 text-center"><Loader2 className="w-6 h-6 animate-spin inline" /></div>;
  const fmt = (cents) => `$${(cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  return (
    <div data-testid="subscriptions-tab">
      <div className="nb-card p-5 mb-6">
        <div className="font-display text-2xl font-extrabold flex items-center gap-2"><Repeat className="w-6 h-6" /> Subscriptions</div>
        <div className="text-sm text-gray-600 mt-1">Recurring offers like memberships, monthly services, or retainers.</div>
      </div>

      <div className="grid grid-cols-3 gap-3 mb-4">
        <div className="nb-card-flat p-4 text-center"><div className="text-xs text-gray-500 font-bold">Offers</div><div className="text-2xl font-extrabold mt-1">{offers.offers.length}</div></div>
        <div className="nb-card-flat p-4 text-center bg-[#F0FDF4]"><div className="text-xs text-gray-500 font-bold">Active subscribers</div><div className="text-2xl font-extrabold mt-1">{active.count}</div></div>
        <div className="nb-card-flat p-4 text-center bg-[#FFEEDD]"><div className="text-xs text-gray-500 font-bold">MRR estimate</div><div className="text-2xl font-extrabold mt-1">{fmt(active.mrr_cents_estimate || 0)}</div></div>
      </div>

      <div className="text-[10px] uppercase tracking-widest font-extrabold text-gray-500 mb-2 px-1">Your subscription offers</div>
      {offers.offers.length === 0 ? (
        <div className="nb-card-flat p-6 text-center text-sm text-gray-600">No subscriptions yet. Add one from the Products tab — set the type to <b>Subscription</b>.</div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-3" data-testid="subscriptions-offers-list">
          {offers.offers.map((p) => (
            <div key={p.product_id} className="nb-card p-4">
              <div className="text-[10px] font-extrabold uppercase tracking-widest text-[#8B5CF6]">Subscription · {p.recurring_interval || "month"}ly</div>
              <div className="font-display text-lg font-extrabold leading-tight mt-1">{p.name}</div>
              <div className="text-2xl font-extrabold mt-2">{fmt(p.price_cents)}<span className="text-sm text-gray-500 font-bold">/{p.recurring_interval || "month"}</span></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
